/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PortalAccountStateDto = {
    NotGranted: 'NotGranted',
    InvitationSent: 'InvitationSent',
    Registered: 'Registered',
    Locked: 'Locked'
} as const;
export type PortalAccountStateDto = typeof PortalAccountStateDto[keyof typeof PortalAccountStateDto];


export function instanceOfPortalAccountStateDto(value: any): boolean {
    for (const key in PortalAccountStateDto) {
        if (Object.prototype.hasOwnProperty.call(PortalAccountStateDto, key)) {
            if (PortalAccountStateDto[key as keyof typeof PortalAccountStateDto] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PortalAccountStateDtoFromJSON(json: any): PortalAccountStateDto {
    return PortalAccountStateDtoFromJSONTyped(json, false);
}

export function PortalAccountStateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortalAccountStateDto {
    return json as PortalAccountStateDto;
}

export function PortalAccountStateDtoToJSON(value?: PortalAccountStateDto | null): any {
    return value as any;
}

export function PortalAccountStateDtoToJSONTyped(value: any, ignoreDiscriminator: boolean): PortalAccountStateDto {
    return value as PortalAccountStateDto;
}

